import { useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_TYPE } from '../constants/searchParamKeys';
import { SEO_NO_LAYOUT_KEY, SEO_NO_MEDIUM_KEY, seoGetKeywords } from '../utils/seo.getKeywords';
export const useSEOKeywords = () => {
    const [searchParams] = useSearchParams();
    const { medium } = useParams();
    const mediumKey = medium ?? SEO_NO_MEDIUM_KEY;
    const layoutKey = searchParams.get(SEARCH_PARAM_KEY_TYPE) ?? SEO_NO_LAYOUT_KEY;
    const [kw1, kw2, kw3] = seoGetKeywords({
        mediumKey: medium,
        layoutKey
    });
    return {
        mediumKey,
        layoutKey,
        kw1,
        kw2,
        kw3
    };
};
